import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PublicationModel, PublicationSaveModel} from '../../../models/publication.model';
import {UserModel} from '../../../models/user.model';
import {PublicationInformationFormPartComponent} from '../base-publication-form-part/publication-information-form-part/publication-information-form-part.component';
import {Observable} from 'rxjs/Observable';
import {FormGroup} from '@angular/forms';
@Component({
    selector: 'app-step-new-publication',
    templateUrl: './step-new-publication.component.html',
    styleUrls: ['./step-new-publication.component.scss']
})
export class StepNewPublicationComponent implements OnInit {
    sections = {
        first: {
            visited: true,
            valid: true
        },
        second: {
            visited: false,
            valid: false
        },
        third: {
            visited: false,
            valid: false
        },
        all: {
            visited: false,
            valid: false
        }
    };

    isValidForm = false;

    @Output('onValidForm')
    onValidForm = new EventEmitter<boolean>();
    @Output('onModelChanged')
    onModelChanged = new EventEmitter<PublicationModel>();
    @Input() publication: PublicationModel = new PublicationModel();
    @Input() loggedUser: UserModel = new UserModel();
    @ViewChild('group2') group2;
    @ViewChild(PublicationInformationFormPartComponent) publicationInformationFormPartComponent: PublicationInformationFormPartComponent;
    constructor() {
    }

    ngOnInit() {
    }

    onVisitSection(index: number) {
        switch (index) {
            case 1:
                this.sections.first.visited = true;
                break;
            case 2:
                this.sections.second.visited = true;
                break;
            case 3:
                if(!this.sections.second.valid){
                    this.group2.toggleOpen();
                    this.publicationInformationFormPartComponent.touchForm();
                }
                this.sections.third.visited = true;
                break;
        }
        this.sections.all.visited = this.sections.third.visited &&
            this.sections.second.visited && this.sections.first.visited;
        this.emitState()
    }

    onValidChange(index: number, $event) {
        switch (index) {
            case 1:
                this.sections.first.valid = $event;
                break;
            case 2:
                this.sections.second.valid = $event;
                break;
            case 3:
                this.sections.third.valid = $event;
                break;
        }
        this.sections.all.valid = this.sections.third.valid &&
            this.sections.second.valid && this.sections.first.valid;
        this.emitState()
    }

    emitState() {
        this.onValidForm.emit(this.sections.all.valid&&this.sections.all.visited);
    }
    onModelUpdate(_publication:PublicationModel) {
        // this.publication. categoryType=_publication.categoryType;
        this.publication.thematicGroupType=_publication.thematicGroupType;
        this.publication.bindingType=_publication.bindingType;
        this.publication.documentType=_publication.documentType;
        this.publication.title=_publication.title;
        this.publication.subtitle=_publication.subtitle;
        this.publication.pages=_publication.pages;
        this.publication.year=_publication.year;
        this.publication.edition=_publication.edition;
        this.publication.languages=_publication.languages;
        this.publication.comment=_publication.comment;
        _publication.bindingType.id===3 ?  this.publication.link=_publication.link : this.publication.link='';
        this.publication.printCount=_publication.printCount;
        this.publication.estimatedPrintDeliveryDate=_publication.estimatedPrintDeliveryDate;
    }
    onAuthorChange($event) {
        this.publication.authors=$event;
    }




}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/step-new-publication/step-new-publication.component.ts